import { callApi } from '@/api/apibase'

export const submitGreenCourse = function (courseId, questions) {
  const requestData = {
    Id: courseId,
    Questions: questions
  }
  return callApi('POST', '/api/external/greencourse/submit', requestData)
}
